export class GatewayIdList {
  gatewayIds: string [] = [];
}